import React, { useEffect, useMemo, useState } from "react";

import PageTitle from "../PageTitle";
import PageSearch from "../PageSearch";
import DialogBox from "../../components/dialog-box/DialogBox";
import EnhancedTable from "../table/Table";
import { useAppDispatch, useAppSelector } from "../../redux/hooks/redux-hooks";
import { fetchSegmentBUMaps } from "../../redux/actions/SegmentBUMapActions";
import { fetchSegmentLOBs } from "../../redux/actions/SegmentLOBActions";
import { fetchBUs } from "../../redux/actions/BUActions";
import Loader from "../../components/loader/Loader";
import { SegmentBUMapModel } from "../../models/SegmentBUMapModel";
import SegmentBuMapForm from "./SegmentBuMapForm";
import { isValidArr } from "../../utility/utils";

export type Mode = "add" | "delete";

type iData = {
  id: string;
  buName: string;
  segmentName: string;
  // status: string;
};

const SegmentBUMapPage = () => {
  const dispatch = useAppDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [mode, setMode] = useState<Mode>("add");
  const [editData, setEditData] = useState<SegmentBUMapModel>();
  const [rootData, setRootData] = useState<iData[]>([]);
  const [filteredData, setFilteredData] = useState<iData[]>([]);

  const allSegmentLOBs = useAppSelector(
    (state) => state.segmentLOB.all_SegmentLOBs
  );
  const allSegmentBus = useAppSelector(
    (state) => state.SegmentBUMap.all_segment_bu_Map
  );
  const allBUs = useAppSelector((state) => state.bu.all_BUs);
  const isSegmentBUMapsFetching = useAppSelector(
    (state) => state.SegmentBUMap.isSegmentBUMapsFetching
  );

  //To fetch all SegmantsBUs, BUs, SegmentLOBs
  useEffect(() => {
    dispatch(fetchSegmentBUMaps());
    dispatch(fetchBUs());
    dispatch(fetchSegmentLOBs());
  }, [dispatch]);

  const columns = useMemo(() => {
    return [
      {
        id: "segmentName",
        numeric: false,
        disablePadding: false,
        label: "Segment",
      },
      {
        id: "buName",
        numeric: false,
        disablePadding: false,
        label: "BU",
      },
      // {
      //   id: "status",
      //   numeric: false,
      //   disablePadding: false,
      //   label: "Status",
      // },
    ];
  }, []);

  useEffect(() => {
    setRootData(() =>
      allSegmentBus.map((segmentBu) => {
        const BUName = allBUs.find((rec) => rec.buid === segmentBu.buid);
        const segmentLOBName = allSegmentLOBs.find(
          (rec) => rec.segmentlobid === segmentBu.segmentId
        );
        return {
          id: `${segmentBu.buid}|${segmentBu.segmentId}`,
          buName: BUName ? BUName.name : "",
          segmentName: segmentLOBName ? segmentLOBName.name : "",
          // status: segmentBu.isActive ? "Active" : "Inactive",
        };
      })
    );
  }, [allSegmentBus, allBUs, allSegmentLOBs]);

  // To set filtered data on change root data
  useEffect(() => {
    setFilteredData(rootData);
  }, [rootData]);

  const handleEdit = (id: string | number) => {
    const idArr = id.toString().split("|");
    const editRec = allSegmentBus.find(
      (rec) => rec.buid === +idArr[0] && rec.segmentId === +idArr[1]
    );
    setMode("delete");
    setEditData(editRec);
    setIsModalOpen(true);
  };

  const createHandler = () => {
    setMode("add");
    setEditData(undefined);
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const searchHandler = (searchVal: string): void => {
    setFilteredData(() =>
      searchVal
        ? rootData.filter((info) =>
            Object.values(info).join("").toLowerCase().includes(searchVal)
          )
        : rootData
    );
  };

  return (
    <>
      {!isValidArr(allSegmentBus) && isSegmentBUMapsFetching ? (
        <Loader />
      ) : null}
      <PageTitle
        title="Segment-BU Mapping"
        btnText="Add Segment-BU Map"
        onClick={createHandler}
      />
      <PageSearch
        placeholder="Search Segment-BU Maps"
        searchHandler={searchHandler}
      />
      <EnhancedTable
        columns={columns}
        data={filteredData}
        handleEdit={handleEdit}
        isEditable={false}
      />
      {isModalOpen && (
        <DialogBox
          isModalOpen={isModalOpen}
          modalTitle={
            mode === "add" ? "Create Segment-BU Map" : "Delete Segment-BU Map"
          }
          handleModalClose={handleModalClose}
        >
          <SegmentBuMapForm
            mode={mode}
            data={editData}
            handleModalClose={handleModalClose}
          />
        </DialogBox>
      )}
    </>
  );
};

export default SegmentBUMapPage;
